import { ISymbolData } from '../../../parseToTree.types';
import { IRemoveItemsByIndexOptions } from './removeItemsByIndex.types';

export const removeItemsByIndex = (opts: IRemoveItemsByIndexOptions): ISymbolData[] => {
  const { list = [], indexesToRemove = [] } = opts;

  if (!indexesToRemove.length) {
    return list;
  }

  return list.filter((item, index) => !indexesToRemove.includes(index));
};
